import {
    CommunicatorAdapter,
    Message,
} from '@/utils/communication/communicationService'
import { Communicator, setupPostQuecast } from '@wikia/post-quecast'

const LIB_ID = '@wikia/post-quecast'

declare let window: {
    [LIB_ID]: unknown
}

export class PostQuecastAdapter implements CommunicatorAdapter {
    private communicator: Communicator

    constructor() {
        this.communicator = new Communicator()
    }

    broadcast<P>(message: Message<P>): void {
        this.communicator.dispatch({ ...message, __global: true })
    }

    listen<P>(listener: (message: Message<P>) => void): void {
        this.communicator.addListener(listener)
    }

    stopListening<P>(listener: (message: Message<P>) => void) {
        this.communicator.removeListener(listener)
    }

    resetInstance(): void {
        delete window[LIB_ID]
    }
}

export const createPostQuecastAdapter = (): PostQuecastAdapter => {
    setupPostQuecast()
    return new PostQuecastAdapter()
}
